import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Button from '../components/common/Button';
import { useT } from '../i18n';

const NotFoundPage = () => {
  const { isAuthenticated } = useAuth();
  const { t } = useT();
  
  return (
    <div className="min-h-screen flex flex-col bg-neutral-50">
      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="max-w-md w-full text-center">
          <img src="/logo.svg" alt="DogBank" className="h-16 mx-auto mb-6" />
          
          <h1 className="text-6xl font-bold text-neutral-800 mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-neutral-700 mb-6">{t('common.page_not_found')}</h2>

          <p className="text-neutral-500 mb-8">
            {t('common.not_found_desc')}
          </p>
          
          <div className="flex flex-col sm:flex-row justify-center space-y-3 sm:space-y-0 sm:space-x-4">
            <Button 
              as={Link} 
              to={isAuthenticated ? '/dashboard' : '/login'} 
              variant="primary"
              size="lg"
            >
              {isAuthenticated ? t('common.back_home') : t('common.go_login')}
            </Button>
            
            <Button 
              as="a" 
              href="mailto:suporte@dogbank.com" 
              variant="outline"
              size="lg"
            >
              {t('common.contact_support')}
            </Button>
          </div>
        </div>
      </div>
      
      <div className="text-center p-4 text-neutral-500 text-sm">
        <p>DogBank © {new Date().getFullYear()} - {t('common.all_rights')}</p>
        <p className="mt-1 text-neutral-400">
          {t('common.demo_notice')}
        </p>
      </div>
    </div>
  );
};

export default NotFoundPage;